import React, { Component } from "react";
import RenderTable from "../common/table";
import { Icon } from "semantic-ui-react";
import auth from "../../services/authService";

class TourTable extends Component {
  columns = [
    {
      path: "child_name",
      label: "Child Name",
      width: "6"
    },
    {
      path: "phone",
      label: "Phone",
      width: "3"
    },
    {
      path: "email",
      label: "Email",
      width: "3"
    },
    {
      path: "preferred_tour_date",
      label: "Preferred Tour Date",
      width: "2"
    },
    {
      key: "actions",
      width: "2",
      content: type =>
      //auth.getCurrentUser().email === "company-unblocker@gondalgroup.ae" && (
          <div>
            <Icon
              name="trash"
              color="red"
              className="clickable"
              onClick={() => this.props.onDelete(type)}
            />

            <Icon
              name="edit"
              color="blue"
              className="clickable"
              onClick={() => this.props.onUpdate(type)}
            />
          </div>
       // )
    }
  ];

  render() {
    const { types, onSort, sortColumn } = this.props;

    return (
      <RenderTable
        columns={this.columns}
        data={types}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default TourTable;
